// extracted by mini-css-extract-plugin
module.exports = {"actions":"be4nJC_k","collectionTitle":"__0oN5LRlA","closeIcon":"h94_opPr","noBoardTip":"__8_vl6tpj","filterContainer":"biLBPorG"};